export const TOTAL="TOTAL"
export const NUM_OF_PERSONS="NUM_OF_PERSONS"
export const KIND_OF_TRIP="KIND_OF_TRIP"
export const SAVE_BUY_DATA="SAVE_BUY_DATA"

